module.exports = __webpack_public_path__ + "static/media/3DPPA37.0d6973c1.jpg";